<template>
  <div>

    <future-alert :end="end" />

    <v-row>

      <v-col cols="12" md="6" lg="4">
        <revenue-by-weekday
          :loading="loading"
          :date-summaries="dateSummaries"
          :channels="channels"
          class="h-100"
        />
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <transactions-by-weekday
          :loading="loading"
          :date-summaries="dateSummaries"
          :channels="channels"
          class="h-100"
        />
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <booking-duration
          :location-ids="locationIds"
          :start="start"
          :end="end"
          :channels="channels"
          class="h-100"
        />
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <peak-occupancy-times
          :location-ids="locationIds"
          :start="start"
          :end="end"
          :channels="channels"
          class="h-100"
        />
      </v-col>

      <v-col cols="12" lg="8">
        <repeat-parkers
          :location-ids="locationIds"
          :start="start"
          :end="end"
          :channels="channels"
          class="h-100"
        />
      </v-col>

    </v-row>

  </div>  
</template>

<script setup lang="ts">

import { useI18n } from 'vue-i18n'
import { useTitle } from '@vueuse/core'

import FutureAlert from './reports/FutureAlert.vue'
import RevenueByWeekday from './reports/RevenueByWeekday.vue'
import TransactionsByWeekday from './reports/TransactionsByWeekday.vue'
import BookingDuration from './reports/BookingDuration.vue'
import RepeatParkers from './reports/RepeatParkers.vue'
// @ts-ignore: don't complain that PeakOccupancyTimes isn't TypeScript (haven't converted it yet, because it's rather hairy)
import PeakOccupancyTimes from './reports/PeakOccupancyTimes.vue'
import type { ReportingDateSummaries } from '../../../services/api-clients/ReportingApi'
import { Temporal } from '@js-temporal/polyfill'

interface Props {
  loading: boolean
  dateSummaries: ReportingDateSummaries
  channels: string[]
  locationIds: number[]
  start: null | Temporal.PlainDate
  end: null | Temporal.PlainDate
}

withDefaults(defineProps<Props>(), {
  loading: false,
  channels: () => [],
})

/**
 *
 */

const { t } = useI18n()
const title = useTitle()
title.value = t('titles.reporting_customers')

</script>
